import Unit from '@leverege/unit';
import { Plugins } from '@leverege/plugin';
import UnitNormalizer from "./UnitNormalizer.js";
function createUnitSpecificObjects() {
  const types = Unit.getUnitTypes();
  types.forEach(type => {
    Plugins.add('Normalizer', {
      valueType: type,
      normalizer: UnitNormalizer.createFor(type)
    });
  });
}
export default {
  install: options => {
    createUnitSpecificObjects();
  }
};